import moment from "moment/moment";

export const subtractWorkDays = (momentDate, daysToSubtract) => {
    var cnt = 0;
    var tmpMoment = moment(momentDate).utc();
    while (cnt < daysToSubtract) {
        tmpMoment = tmpMoment.subtract(1, 'days');
        if (tmpMoment.weekday() != moment().day("Sunday").weekday() && tmpMoment.weekday() != moment().day("Saturday").weekday()) {
            cnt = cnt + 1;
        }
    }

    return tmpMoment;
};

export const renderLocalDateFromUtcDate = (utcDate) => {
    return moment.utc(utcDate).local().format('DD.MM.YYYY HH:mm')
};


// WEBPACK FOOTER //
// ./src/admin/services/DateModule.js